import { format } from "date-fns";
import { InputUserDelete } from "@scrile/api-provider/dist/api/UserProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import config from "@/config";

const RESTORE_DURATION = 1000 * 60 * 60 * 24 * config.restoreAccountInterval;
export default function useUserDelete() {
  const { updateUser } = useAuthUser();
  const restoreDate = format(new Date(Date.now() + RESTORE_DURATION), "dd.MM.yyyy");

  const restoreUser = async () => {
    const restoredUser = await providers.UserProvider.restore();
    updateUser(restoredUser);
  };
  const deleteUser = async (data: InputUserDelete) => {
    await providers.UserProvider.delete({ data });
  };

  return {
    restoreInterval: config.restoreAccountInterval,
    restoreDate,
    restoreUser,
    deleteUser,
  };
}
